import trucoshiSmall from './assets/trucoshi-384.webp?no-inline'
import trucoshiMedium from './assets/trucoshi-768.webp?no-inline'
import trucoshiLarge from './assets/trucoshi-1440.webp?no-inline'
import mifulboSmall from './assets/mifulbo-384.webp?no-inline'
import mifulboMedium from './assets/mifulbo-768.webp?no-inline'
import mifulboLarge from './assets/mifulbo-1440.webp?no-inline'
import huertokuSmall from './assets/huertoku-384.webp?no-inline'
import huertokuMedium from './assets/huertoku-768.webp?no-inline'
import huertokuLarge from './assets/huertoku-1440.webp?no-inline'
import gamestrumentsSmall from './assets/gamestruments-384.webp?no-inline'
import gamestrumentsMedium from './assets/gamestruments-768.webp?no-inline'
import gamestrumentsLarge from './assets/gamestruments-1440.webp?no-inline'
import chatSmall from './assets/chatwithawebsite-384.webp?no-inline'
import chatMedium from './assets/chatwithawebsite-768.webp?no-inline'
import chatLarge from './assets/chatwithawebsite-1440.webp?no-inline'
import elhechoSmall from './assets/elhecho-384.webp?no-inline'
import elhechoMedium from './assets/elhecho-768.webp?no-inline'
import elhechoLarge from './assets/elhecho-1440.webp?no-inline'
import pocketcircuitSmall from './assets/pocketcircuit-384.webp?no-inline'
import pocketcircuitMedium from './assets/pocketcircuit-768.webp?no-inline'
import pocketcircuitLarge from './assets/pocketcircuit-1440.webp?no-inline'

const SCREENSHOT_WIDTHS = [384, 768, 1440] as const
export const SCREENSHOT_SIZES = '(max-width: 900px) calc(100vw - 1.8rem), 176px'

function screenshot(sources: [string, string, string], height = 900) {
  return {
    src: sources[1],
    srcSet: sources.map((src, index) => `${src} ${SCREENSHOT_WIDTHS[index]}w`).join(', '),
    width: SCREENSHOT_WIDTHS[2],
    height,
  }
}

export type ScreenshotImage = ReturnType<typeof screenshot>

export const SCREENSHOTS = {
  trucoshi: screenshot([trucoshiSmall, trucoshiMedium, trucoshiLarge]),
  mifulbo: screenshot([mifulboSmall, mifulboMedium, mifulboLarge]),
  huertoku: screenshot([huertokuSmall, huertokuMedium, huertokuLarge], 780),
  gamestruments: screenshot([gamestrumentsSmall, gamestrumentsMedium, gamestrumentsLarge]),
  chat: screenshot([chatSmall, chatMedium, chatLarge]),
  elhecho: screenshot([elhechoSmall, elhechoMedium, elhechoLarge]),
  pocketcircuit: screenshot([pocketcircuitSmall, pocketcircuitMedium, pocketcircuitLarge], 810),
}
